import { fork } from 'redux-saga/effects';

import CustomerGateway from '~apis/customer';
import { RootSagaReturnType } from '~types/saga';

import watchGetCustomerListing from './getCustomerListing';
import watchCreateNewCustomer from './createNewCustomer';
import watchGetCustomerDetails from './getCustomerDetails';
import watchDeleteCustomer from './deleteCustomer';
import watchEditCustomerDetails from './editCustomerDetails';
import watchGetCustomerTransactions from './getCustomerTransaction';
import watchGetAllCustomers from './getAllCustomers';
import watchGetCustomerInventory from './getCustomerInventory';
import watchExportCustomerListing from './exportCustomerListing';
import watchCreateCollateral from './createCollateral';
import watchGetCollateralMarketValue from './getCollateralMarketValue';
import watchGetCustomerCollateralListing from './getCustomerCollateralListing';
import watchDeleteCustomerCollateral from './deleteCustomerCollateral';
import ApprovalGateway from '~apis/approval';
import watchCreateReleaseEarmark from './createEarmarkRelease';

export default (api: CustomerGateway, approvalApi: ApprovalGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetCustomerListing, api);
        yield fork(watchCreateNewCustomer, api);
        yield fork(watchGetCustomerDetails, api);
        yield fork(watchDeleteCustomer, api);
        yield fork(watchEditCustomerDetails, api);
        yield fork(watchGetCustomerTransactions, api);
        yield fork(watchGetAllCustomers, api);
        yield fork(watchGetCustomerInventory, api);
        yield fork(watchExportCustomerListing, api);
        yield fork(watchCreateCollateral, api);
        yield fork(watchGetCollateralMarketValue, api);
        yield fork(watchGetCustomerCollateralListing, api);
        yield fork(watchDeleteCustomerCollateral, approvalApi);
        yield fork(watchCreateReleaseEarmark, api);
    }

    return {
        rootSaga,
    };
};
